"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useResizeObserver = useResizeObserver;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
function useResizeObserver(targetRef) {
  var _useState = (0, _react.useState)({}),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    contentRect = _useState2[0],
    setContentRect = _useState2[1];
  var resizeObserver = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined' && 'ResizeObserver' in window) {
      observe(ResizeObserver);
    }
    function observe(Observer) {
      resizeObserver.current = new Observer(function (entries) {
        if (entries) {
          setContentRect(function () {
            return copy(entries[0].contentRect);
          });
        }
      });
      if (targetRef.current) {
        resizeObserver.current.observe(targetRef.current);
      }
    }
    return disconnect;
  }, [targetRef]);
  function disconnect() {
    if (resizeObserver.current) {
      resizeObserver.current.disconnect();
    }
  }
  return contentRect;
}
function copy(obj) {
  return JSON.parse(JSON.stringify(obj));
}